import { createTheme } from '@mui/material/styles';

// Legacy MUI theme. Kept in dark mode so remaining MUI-rendered components
// blend with the Tailwind/shadcn dark shell. Being phased out per DESIGN.md.
export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#2391d6' },
    secondary: { main: '#e86c87' },
    background: { default: '#0d1320', paper: '#141b2b' },
  },
  typography: {
    fontFamily: 'Inter, "Helvetica", "Arial", sans-serif',
    h1: { fontSize: '2.5rem', fontWeight: 500 },
    h2: { fontSize: '2rem', fontWeight: 500 },
    h3: { fontSize: '1.75rem', fontWeight: 500 },
    h4: { fontSize: '1.5rem', fontWeight: 500 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none' },
      },
    },
  },
});
